import { render, staticRenderFns } from "./NewCarorder.vue?vue&type=template&id=711159dc&scoped=true&"
import script from "./NewCarorder.vue?vue&type=script&lang=ts&"
export * from "./NewCarorder.vue?vue&type=script&lang=ts&"
import style0 from "./NewCarorder.vue?vue&type=style&index=0&id=711159dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711159dc",
  null
  
)

export default component.exports